import React from 'react'
import { HiSearch, HiX } from 'react-icons/hi'

export default function ProductsSearch({ searchQuery, setSearchQuery }) {
    return (
        <div className="sticky top-20 z-40 bg-white backdrop-blur-md shadow-xl border-b-2 border-medical-blue-300 py-5">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center">
                    {/* Search Bar */}
                    <div className="flex-1 w-full relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-medical-blue-200 to-medical-teal-200 rounded-2xl opacity-30 blur-md"></div>
                        <div className="relative">
                            <HiSearch className="absolute left-6 top-1/2 -translate-y-1/2 w-6 h-6 text-medical-blue-600 z-10" />
                            <input
                                type="text"
                                placeholder="Search products, equipment, or supplies..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="w-full pl-16 pr-14 py-4 bg-white border-3 border-medical-blue-400 rounded-2xl focus:ring-4 focus:ring-medical-blue-300 focus:border-medical-blue-600 outline-none transition-all shadow-xl hover:shadow-2xl text-gray-900 placeholder:text-gray-500 font-medium text-base"
                                style={{ borderWidth: '3px' }}
                            />
                            {searchQuery && (
                                <button
                                    onClick={() => setSearchQuery('')}
                                    className="absolute right-6 top-1/2 -translate-y-1/2 p-2 rounded-full bg-medical-blue-500 text-white hover:bg-medical-blue-600 transition-all shadow-md z-10"
                                >
                                    <HiX className="w-5 h-5" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

